export default __webpack_public_path__ + "static/media/preloaderDotsAnimation.c6d50eb0.svg";